import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { ViewPageLayout } from 'pages/settings/pages/billing/layout/ViewPageLayout/ViewPageLayout'
import { AddSubscriptionAccessLayout } from 'pages/settings/pages/billing/layout/AddSubscriptionAccessLayout'
import { BillingViewProvider } from 'pages/settings/pages/billing/context/billingViewContext'
import { UpgradePage } from 'pages/settings/pages/billing/pages/upgrade/ui/upgradePage'

export const AddSubscriptionRouter = observer(() => {
  return (
    <Routes>
      <Route element={<AddSubscriptionAccessLayout />}>
        <Route
          index
          element={
            <BillingViewProvider>
              <ViewPageLayout>
                <UpgradePage />
              </ViewPageLayout>
            </BillingViewProvider>
          }
        />
      </Route>
    </Routes>
  )
})
